import { useState } from "react";
import { useSession } from "@otto/plattform";
import { ClassTable } from "./ClassTable.js";
import { NewClassForm } from "./NewClassForm.js";
import { useClasses, useCreateClass } from "../lib/data.js";
import { assignableTo } from "../../courses/lib/assign.js";
import { useCourseCatalog } from "../../courses/lib/data.js";
import styles from "../../../shared/components/shell.module.css";

export function ClassList() {
  const { client, state } = useSession();
  const identity = state.kind === "signedIn" ? state.identity : null;
  const profile = identity?.profile;

  const classes = useClasses(client, profile?.schoolId ?? "");
  const catalog = useCourseCatalog(client);
  const create = useCreateClass(client, profile?.schoolId ?? "");
  const [formOpen, setFormOpen] = useState(false);

  // Eine frische Klasse führt noch nichts – übrig bleiben damit genau die
  // Lehrgänge ohne Vorgänger. Weitere kommen später im Klassendetail dazu.
  const startable = assignableTo(catalog.data ?? [], []);

  if (!profile || !identity) return null;

  return (
    <>
      <div className={styles.card}>
        <h1 className={styles.title}>Klassen</h1>
        <p className={styles.subtitle}>
          Sie sehen ausschließlich Ihre eigenen Klassen. Kinder haben kein Konto – jedes
          übt mit einem Übungscode, und welches Kind welchen Code hat, wissen nur Sie.
        </p>

        {classes.isPending && <p className={styles.empty}>Klassen werden geladen …</p>}
        {classes.isError && (
          <div className={`${styles.notice} ${styles.noticeError}`}>
            Die Klassen konnten nicht geladen werden.
          </div>
        )}
        {classes.data?.length === 0 && (
          <p className={styles.empty}>Noch keine Klasse angelegt.</p>
        )}
        {classes.data && classes.data.length > 0 && <ClassTable classes={classes.data} />}
      </div>

      <div className={`${styles.card} ${styles.spaced}`}>
        {formOpen ? (
          <NewClassForm
            pending={create.isPending}
            failed={create.isError}
            courses={startable}
            onCancel={() => setFormOpen(false)}
            onCreate={(input) => {
              const course = startable.find((o) => o.curriculumId === input.curriculumId);
              if (!course?.latestVersionId) return;
              create.mutate(
                {
                  name: input.name,
                  schoolYear: input.schoolYear,
                  curriculumId: course.curriculumId,
                  curriculumVersionId: course.latestVersionId,
                  teacherId: identity.user.id,
                },
                { onSuccess: () => setFormOpen(false) },
              );
            }}
          />
        ) : (
          <button
            type="button"
            className={styles.button}
            // Die Marke der Führung. Sie steht hier, am echten Knopf, und nicht
            // in einem Overlay, das seine Position ausmisst - die Regel dazu
            // liegt in `features/onboarding/components/tour.module.css`.
            data-tour="neue-klasse"
            onClick={() => setFormOpen(true)}
          >
            Neue Klasse anlegen
          </button>
        )}
      </div>
    </>
  );
}
